var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Image, View } from 'react-native';
import { getSectionHeaderWidgetStyles } from './SectionHeaderWidgetStyles';
import { getTestId, useBreakpoint, Typography } from '@airtel/air-design-system';
export var SectionHeaderWidgetComponent = props => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'SectionHeaderWidget' : _props$testID,
    style = props.style,
    title = props.title,
    description = props.description,
    imageUrl = props.imageUrl,
    titleAccessibilityProps = props.titleAccessibilityProps,
    descriptionAccessibilityProps = props.descriptionAccessibilityProps,
    restProps = __rest(props, ["testID", "style", "title", "description", "imageUrl", "titleAccessibilityProps", "descriptionAccessibilityProps"]);
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var sectionHeaderWidgetStyles = getSectionHeaderWidgetStyles(props, isSmallScreen);
  return _jsxs(View, Object.assign({}, getTestId(testID), {
    style: [sectionHeaderWidgetStyles.container, style]
  }, restProps, {
    children: [_jsx(View, Object.assign({
      style: sectionHeaderWidgetStyles.textContainer
    }, {
      children: _jsxs(View, Object.assign({
        style: {
          flex: 1
        }
      }, {
        children: [!!title && _jsx(Typography, Object.assign({
          text: title,
          type: (isSmallScreen ? 'h6' : 'h5') + "-bold",
          style: sectionHeaderWidgetStyles.titleText
        }, titleAccessibilityProps || {}, getTestId(testID, 'title'))), !!description && _jsx(Typography, Object.assign({
          text: description,
          style: sectionHeaderWidgetStyles.desc,
          type: "body-para-" + (isSmallScreen ? 'sm' : 'md')
        }, descriptionAccessibilityProps || {}, getTestId(testID, 'description')))]
      }))
    })), !!imageUrl && _jsx(View, Object.assign({
      style: sectionHeaderWidgetStyles.imageContainer
    }, {
      children: _jsx(Image, Object.assign({
        source: {
          uri: imageUrl
        },
        resizeMode: 'contain',
        style: sectionHeaderWidgetStyles.imageStyle
      }, getTestId(testID, 'image')))
    }))]
  }));
};
SectionHeaderWidgetComponent.genericRendererKey = 'AirSectionHeaderWidget';